import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Formik } from 'formik';
import { useCallback, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { useIntercom } from 'react-use-intercom';
import { SendFeedbackMessage } from '../../lib/telegram';
import SubmitButton from '../Buttons/submitButton';
import { ErrorDisplay } from '../Pages/Swap/Form/SecondaryComponents/validationError/ErrorDisplay';
import ErrorDismissButton from '../Pages/Swap/Form/SecondaryComponents/validationError/ErrorDismissButton';
import FailIcon from '../Icons/FailIcon';
const SendFeedback = ({ onSend }) => {
    const initialValues = { Feedback: '' };
    const { boot, show, update } = useIntercom();
    const [error, setError] = useState("");
    const [sent, setSent] = useState(false);
    const handleSendFeedback = useCallback(async (values) => {
        if (values.Feedback.length === 0)
            return;
        setError("");
        try {
            const sender = "No login";
            const res = await SendFeedbackMessage(sender, values.Feedback);
            if (!res.ok) {
                throw new Error(res.description || "Could not send feedback, something went wrong");
            }
            setSent(true);
        }
        catch (e) {
            setError(e.message);
        }
    }, []);
    if (sent) {
        return (_jsxs("div", { className: "flex flex-col items-center justify-center text-center gap-3 py-10", children: [_jsx(CheckCircle2, { className: "h-10 w-10 text-primary" }), _jsx("p", { className: "text-base text-primary-text font-medium", children: "Thank you for reaching out and providing us with valuable feedback." }), _jsx(SubmitButton, { type: "button", onClick: onSend, children: "Close" })] }));
    }
    return (_jsx(Formik, { initialValues: initialValues, onSubmit: handleSendFeedback, validateOnMount: true, validate: (values) => {
            const errors = {};
            if (values.Feedback.length === 0) {
                errors.Feedback = "This field is required and cannot be empty";
            }
            return errors;
        }, children: ({ handleChange, isValid, isSubmitting }) => (_jsxs(Form, { className: 'flex flex-col justify-between', children: [_jsx("div", { className: 'space-y-4 h-full mt-2', children: _jsx("p", { className: 'text-base text-left font-roboto text-secondary-text font-light', children: "Please help us shape the product, catch bugs, and prioritize features. Your feedback will go directly into our Telegram channel." }) }), _jsxs("div", { className: "text-primary-text text-sm space-y-4 flex flex-col pt-8", children: [_jsx("textarea", { id: 'Feedback', name: 'Feedback', onChange: e => {
                                handleChange(e);
                            }, className: "h-40 max-h-60 appearance-none block bg-secondary-700 text-primary-text border border-secondary-500 rounded-md py-3 px-4 mb-3 leading-tight focus:ring-0 focus:bg-secondary-500 focus:border-secondary-100 " }), _jsx("button", { type: "button", onClick: () => {
                                boot();
                                show();
                                update();
                            }, className: "text-center disabled:text-primary-800 text-primary border-0 font-semibold rounded-md focus:outline-hidden transform hover:-translate-y-0.5 transition duration-200 ease-in-out", children: "Need help?" }), error ? (_jsx(ErrorDisplay, { icon: _jsx(FailIcon, { className: "h-5 w-5" }), title: "Couldn't send feedback", message: error, action: _jsx(ErrorDismissButton, { onClick: () => setError("") }) })) : null, _jsx(SubmitButton, { type: 'submit', isDisabled: isSubmitting || !isValid, isSubmitting: isSubmitting, children: "Send" })] })] })) }));
};
export default SendFeedback;
